module.exports = __webpack_public_path__ + "img/2.07b4e58d.png";